<template>
  <div class="download-management-container">
    <div class="download-management-content">
      <div class="download-management-header">
        <h2>下载管理</h2>
        <p>管理不同平台的下载链接</p>
      </div>

      <el-button type="primary" @click="dialogVisible = true" style="margin-bottom: 20px;">
        <i class="el-icon-plus"></i> 添加下载链接
      </el-button>

      <el-table :data="downloads" style="width: 100%" border>
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="version" label="版本" width="120"></el-table-column>
        <el-table-column prop="platform" label="平台" width="120">
          <template slot-scope="scope">
            <el-tag :type="getPlatformType(scope.row.platform)">
              {{ getPlatformName(scope.row.platform) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="download_url" label="下载链接" min-width="300"></el-table-column>
        <el-table-column prop="description" label="描述" min-width="200"></el-table-column>
        <el-table-column prop="download_count" label="下载次数" width="100"></el-table-column>
        <el-table-column prop="is_active" label="状态" width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.is_active" @change="updateStatus(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="editDownload(scope.row)">
              编辑
            </el-button>
            <el-button type="danger" size="small" @click="deleteDownload(scope.row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 添加/编辑对话框 -->
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="500px"
      >
        <el-form :model="form" label-width="80px">
          <el-form-item label="版本">
            <el-input v-model="form.version" placeholder="请输入版本号"></el-input>
          </el-form-item>
          <el-form-item label="平台">
            <el-select v-model="form.platform" placeholder="请选择平台">
              <el-option label="Windows" value="windows"></el-option>
              <el-option label="macOS" value="macos"></el-option>
              <el-option label="Linux" value="linux"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下载链接">
            <el-input v-model="form.download_url" placeholder="请输入下载链接"></el-input>
          </el-form-item>
          <el-form-item label="描述">
            <el-input v-model="form.description" placeholder="请输入描述" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-switch v-model="form.is_active"></el-switch>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveDownload">确定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownloadManagement',
  data() {
    return {
      downloads: [],
      dialogVisible: false,
      dialogTitle: '添加下载链接',
      form: {
        id: null,
        version: '',
        platform: '',
        download_url: '',
        description: '',
        is_active: true
      }
    }
  },
  mounted() {
    this.getDownloads()
  },
  methods: {
    getDownloads() {
      this.$axios.get('/admin/downloads')
        .then(response => {
          if (response.data.code === 200) {
            this.downloads = response.data.data
          }
        })
        .catch(() => {
          this.$message.error('获取下载链接失败')
        })
    },
    addDownload() {
      this.dialogTitle = '添加下载链接'
      this.form = {
        id: null,
        version: '',
        platform: '',
        download_url: '',
        description: '',
        is_active: true
      }
      this.dialogVisible = true
    },
    editDownload(row) {
      this.dialogTitle = '编辑下载链接'
      this.form = {
        id: row.id,
        version: row.version,
        platform: row.platform,
        download_url: row.download_url,
        description: row.description,
        is_active: row.is_active
      }
      this.dialogVisible = true
    },
    saveDownload() {
      if (!this.form.version || !this.form.platform || !this.form.download_url) {
        this.$message.warning('请填写必填字段')
        return
      }

      if (this.form.id) {
        // 更新
        this.$axios.put(`/admin/downloads/${this.form.id}`, this.form)
          .then(response => {
            if (response.data.code === 200) {
              this.$message.success('更新成功')
              this.dialogVisible = false
              this.getDownloads()
            } else {
              this.$message.error('更新失败')
            }
          })
          .catch(() => {
            this.$message.error('更新失败')
          })
      } else {
        // 创建
        this.$axios.post('/admin/downloads', this.form)
          .then(response => {
            if (response.data.code === 200) {
              this.$message.success('创建成功')
              this.dialogVisible = false
              this.getDownloads()
            } else {
              this.$message.error('创建失败')
            }
          })
          .catch(() => {
            this.$message.error('创建失败')
          })
      }
    },
    deleteDownload(id) {
      this.$confirm('确定要删除这个下载链接吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        this.$axios.delete(`/admin/downloads/${id}`)
          .then(response => {
            if (response.data.code === 200) {
              this.$message.success('删除成功')
              this.getDownloads()
            } else {
              this.$message.error('删除失败')
            }
          })
          .catch(() => {
            this.$message.error('删除失败')
          })
      })
      .catch(() => {
        // 取消删除
      })
    },
    updateStatus(row) {
      this.$axios.put(`/admin/downloads/${row.id}`, row)
        .then(response => {
          if (response.data.code !== 200) {
            this.$message.error('更新状态失败')
            // 恢复原来的状态
            row.is_active = !row.is_active
          }
        })
        .catch(() => {
          this.$message.error('更新状态失败')
          // 恢复原来的状态
          row.is_active = !row.is_active
        })
    },
    getPlatformType(platform) {
      const types = {
        windows: 'primary',
        macos: 'success',
        linux: 'warning'
      }
      return types[platform] || 'info'
    },
    getPlatformName(platform) {
      const names = {
        windows: 'Windows',
        macos: 'macOS',
        linux: 'Linux'
      }
      return names[platform] || platform
    }
  }
}
</script>

<style scoped>
.download-management-container {
  padding: 20px 0;
}

.download-management-content {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #333;
}

.download-management-header {
  margin-bottom: 30px;
}

.download-management-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.download-management-header p {
  font-size: 14px;
  color: #666;
  margin: 0;
}
</style>